<template>
  <div class="app-container">
    <div class="analysis-title">
      统计时间：
      <div class="time">
        <el-select
          v-model="time"
          placeholder="请选择"
          @change="definition"
          size="small"
        >
          <el-option
            v-for="item in timeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <el-date-picker
        v-if="isTime"
        v-model="dataMeth"
        size="small"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="~"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        @change="dataTime"
      >
      </el-date-picker>
    </div>
    <div class="analysis-quantity">
      <div class="li" v-for="(item, index) in replyList" :key="index">
        <i class="icon el-icon-s-order"></i>
        <div>
          {{ item.title }} <i class="el-icon-info" :title="item.tips"></i>
          <b>{{ item.num }}</b>
        </div>
      </div>
    </div>
    <div class="analysis-trend">
      <div class="trend-left">
        <div class="title">诉求提交趋势</div>
        <div class="echart" ref="leftCharts"></div>
      </div>
      <div class="trend-right">
        <div class="title">诉求分类占比</div>
        <div
          class="empty-status"
          v-if="appealTypeMoth && appealTypeMoth.length === 0"
        >
          <i class="el-icon-receiving"></i>
          <span>暂无数据</span>
        </div>
        <div class="echart" ref="rankingCharts"></div>
      </div>
    </div>
    <div class="analysis-ranking">
      <div class="ranking-left">
        <div class="title">
          <span>区县诉求排行榜</span>
          <el-radio-group
            v-model="tabPosition"
            @change="ranking"
            style="margin: 10px;"
            size="small"
          >
            <el-radio-button label="1" border>企业提交</el-radio-button>
            <el-radio-button label="2" border>答复</el-radio-button>
          </el-radio-group>
        </div>
        <div class="ranking_list" v-if="cityList && cityList.length > 0">
          <div class="li" v-for="(item, index) in cityList" :key="index">
            <b>{{ index + 1 }}</b>
            <span>{{ item.label }}</span>
            <div
              class="line"
              :style="'width:' + item.num / lineNum + 'px'"
            ></div>
            <span>{{ item.num }}</span>
          </div>
        </div>
        <div class="empty-status" v-else>
          <i class="el-icon-receiving"></i>
          <span>暂无数据</span>
        </div>
      </div>
      <div class="ranking-right">
        <div class="title">注：答复率和满意率只统计累计数据</div>
        <div class="right-content">
          <div class="right-echarts">
            <el-progress
              type="circle"
              :stroke-width="15"
              :percentage="satisfied.rate"
              color="#6ad389"
            ></el-progress>
            <div class="probability">
              答复率
              <i class="el-icon-info" title="包括已完结、已评价的诉求"></i>
            </div>
          </div>
          <div class="right-echarts">
            <el-progress
              type="circle"
              :stroke-width="15"
              :percentage="satisfied.num"
              color="#fcdb56"
            ></el-progress>
            <div class="probability">
              满意率
              <i
                class="el-icon-info"
                title="评价满意度3、4、5星/所有已评价数"
              ></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const echarts = require('echarts')
import { statisticsAnalysis, areaSort } from '@api/yardAppeal'
export default {
  data() {
    return {
      time: '全部',
      isTime: false,
      dataMeth: [],
      satisfied: {
        num: 0,
        rate: 0
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      timeList: [
        {
          value: 0,
          label: '全部'
        },
        {
          value: 1,
          label: '自定义'
        }
      ],
      replyList: [
        {
          title: '诉求提交数',
          tips: '企业提交的诉求数量',
          num: '',
          value: 'appealNum'
        },
        {
          title: '已答复的诉求',
          tips: '包括已完结、已评价的诉求',
          num: '',
          value: 'haveReply'
        },
        {
          title: '正在受理中的诉求',
          tips: '包括已完结、已评价的诉求',
          num: '',
          value: 'beingAccepted'
        },
        {
          title: '交办信访办的诉求',
          tips: '包括信访办未受理和已受理的数量',
          num: '',
          value: 'submit'
        }
      ],
      centerChart: null,
      rankingChart: null,
      tabPosition: '1',
      cityList: [],
      appealTypeMoth: [],
      lineNum: 1
    }
  },
  created() {
    this.getList()
    this.cityRanking()
  },
  mounted() {
    this.centerChart = echarts.init(this.$refs.leftCharts)
    this.rankingChart = echarts.init(this.$refs.rankingCharts)
    window.addEventListener('resize', () => {
      this.centerChart.resize()
      this.rankingChart.resize()
    })
  },
  methods: {
    // 图表
    getList() {
      let params = {
        startTime:
          this.dataMeth && this.dataMeth.length > 0 ? this.dataMeth[0] : '',
        endTime:
          this.dataMeth && this.dataMeth.length > 0 ? this.dataMeth[1] : ''
      }
      statisticsAnalysis(params).then(res => {
        const { code, data } = res.data
        if (code == '0000') {
          this.satisfied.num = data.satisfiedRatio
          this.satisfied.rate = data.haveReplyRatio
          this.replyList.map(val => {
            val.num = data[val.value]
          })

          // 诉求提交趋势
          const mothe = data.appealTrend.map(f => {
            return f.label
          })
          const numse = data.appealTrend.map(f => {
            return f.num
          })
          this.initChart(mothe, numse)
          // 诉求分类占比
          this.appealTypeMoth = data.appealType.map(f => {
            return { name: f.label, value: f.num }
          })

          this.initCharts(this.appealTypeMoth, data.appealTypeNum)
        }
      })
    },
    // city 列表
    cityRanking() {
      const params = {
        startTime:
          this.dataMeth && this.dataMeth.length > 0 ? this.dataMeth[0] : '',
        endTime:
          this.dataMeth && this.dataMeth.length > 0 ? this.dataMeth[1] : '',
        type: this.tabPosition
      }
      areaSort(params).then(res => {
        const { code, data } = res.data
        if (code == '0000') {
          this.cityList = data
          const maxNum = Math.max.apply(
            Math,
            this.cityList.map(item => {
              return item.num
            })
          )
          if (maxNum < 100) {
            this.lineNum = 1
          } else if (maxNum < 1000 && maxNum > 100) {
            this.lineNum = 10
          } else if (maxNum < 10000 && maxNum > 1000) {
            this.lineNum = 100
          } else if (maxNum < 100000 && maxNum > 10000) {
            this.lineNum = 1000
          }
        }
      })
    },
    definition(val) {
      if (val === 0) {
        this.isTime = false
        this.dataMeth = []
      } else {
        this.isTime = true
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)

        this.dataMeth = [this.timeFileter(start), this.timeFileter(end)]
      }
      this.getList()
      this.cityRanking()
    },
    timeFileter(time) {
      var date = new Date(time)
      var seperator1 = '-'
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate

      return currentdate
    },
    initChart(mothe, numse) {
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['Mon'],
          bottom: 45
        },
        grid: {
          top: 20,
          bottom: 100
        },
        xAxis: {
          type: 'category',
          data: mothe
        },

        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 100,
            starValue: 100
          },
          {
            start: 0,
            end: 20
          }
        ],
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: 'rgb(240,240,240)'
            }
          }
        },
        series: [
          {
            name: 'Mon',
            data: numse,
            type: 'line',
            smooth: true,
            showSymbol: true,
            itemStyle: {
              color: 'rgba(0, 112, 255, 1)'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(0, 112, 255, 0.4)'
                },
                {
                  offset: 1,
                  color: 'transparent'
                }
              ])
            }
          }
        ]
      }
      this.centerChart.setOption(option)
    },
    initCharts(moth, num) {
      const option = {
        tooltip: {
          trigger: 'item'
        },

        legend: {
          orient: 'vertical',
          left: '10%',
          top: '30%'
        },
        graphic: {
          type: 'text',
          left: '55%',
          top: '45%',
          style: {
            text: '总数',
            textAlign: 'center',
            fill: '#333',
            fontSize: 16
          }
        },
        title: {
          text: num,
          left: '54%',
          top: '55%',
          textStyle: {
            fontSize: 25,
            fill: '#333',
            align: 'center'
          }
        },
        series: [
          {
            type: 'pie',
            radius: ['60%', '80%'],
            center: ['58%', '51%'],
            data: moth,

            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      this.rankingChart.setOption(option)
    },
    ranking(val) {
      this.tabPosition = val
      this.cityRanking()
    },
    dataTime() {
      this.getList()
      this.cityRanking()
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  padding: 24px 0;
  .empty-status {
    display: inline-block;
    width: 600px;
    height: 210px;
    text-align: center;
    line-height: 30px;
    color: #1890ff;
    i {
      margin-top: 60px;
      font-size: 45px;
    }
    span {
      display: block;
    }
  }
  .analysis {
    &-title {
      display: flex;
      line-height: 30px;
      padding: 0 36px;
      font-size: 16px;
      .time {
        margin-right: 10px;
      }
    }
    &-quantity {
      display: flex;
      justify-content: space-between;
      padding-right: 100px;
      padding: 0 36px 20px;

      .li {
        display: flex;
        margin-top: 10px;
        .icon {
          display: inline-block;
          width: 30px;
          height: 30px;
          line-height: 30px;
          background-color: #3c9dff;
          border-radius: 50%;
          color: #fff;
          text-align: center;
          font-size: 19px;
          margin: 10px 20px 10px 0;
        }
        > div {
          color: #999999;
          font-size: 14px;
          i {
            cursor: pointer;
          }
          b {
            display: block;
            color: #000;
            font-size: 28px;
            margin-top: 5px;
          }
        }
      }
    }
    &-trend {
      display: flex;
      border-top: 10px solid #f0f2f5;
      .trend-left {
        color: #000;
        font-size: 18px;
        border-right: 10px solid #f0f2f5;

        flex: 1;
        .title {
          height: 50px;
          line-height: 50px;
          border-bottom: 1px solid #f0f2f5;
          font-weight: 500;
          letter-spacing: 1px;
          padding-left: 20px;
        }
        .echart {
          width: 100%;
          height: 300px;
        }
      }
      .trend-right {
        width: 35%;
        height: 286px;
        color: #000;
        font-size: 18px;
        overflow: hidden;
        .title {
          height: 50px;
          line-height: 50px;
          border-bottom: 1px solid #f0f2f5;
          font-weight: 500;
          letter-spacing: 1px;
          padding-left: 20px;
        }
        .echart {
          width: 100%;
          height: 230px;
        }
      }
    }
    &-ranking {
      display: flex;
      border-top: 10px solid #f0f2f5;
      .ranking-left {
        flex: 1.5;
        border-right: 10px solid #f0f2f5;
        font-size: 16px;
        .title {
          height: 50px;
          line-height: 50px;
          border-bottom: 1px solid #f0f2f5;
          font-weight: 500;
          letter-spacing: 1px;
          padding-left: 20px;
          display: flex;
          justify-content: space-between;
        }
        .ranking_list {
          height: 250px;
          overflow-y: scroll;
          padding: 0 0 50px 24px;
          .li {
            height: 30px;
            display: flex;
            margin-top: 10px;
            padding-top: 10px;
            b {
              display: inline-block;
              width: 25px;
              height: 25px;
              line-height: 25px;
              text-align: center;
              border-radius: 50%;
              background-color: #f0f2f5;
              font-weight: 500;
              margin-top: -4px;
            }
            span {
              margin: 0 30px;
              width: 120px;
            }
            .line {
              height: 10px;
              border-radius: 6px;
              background-color: #0070ff;
              margin-left: 100px;
            }
          }
          .li:nth-child(1),
          .li:nth-child(2),
          .li:nth-child(3) {
            b {
              background-color: #314659;
              color: #fff;
            }
          }
        }
      }
      .ranking-right {
        flex: 2;
        padding: 20px 30px 0;
        font-size: 16px;
        .title {
          color: #999999;
        }
        .right-content {
          display: flex;
          justify-content: space-around;

          .right-echarts {
            text-align: center;
            padding-top: 20px;
            > div {
              margin: 10px 0;
            }
            .probability {
              margin-left: 14px;
              i {
                color: #999;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }
}
/deep/.el-progress__text {
  font-size: 20px !important;
}
/deep/.el-progress-bar {
  width: 600px;
}
/deep/.el-progress-bar__outer {
  // background-color: transparent;
  background-color: #66cc99;
  border-radius: 0;
}

/deep/.el-progress-bar__inner {
  border-radius: 0;
  color: transparent;
}
</style>
